import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneArrowInFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M9.2 10.45c-.449-.27-1.162-.772-2.013-1.621-.854-.854-1.355-1.57-1.625-2.02-.19-.314-.187-.695-.043-1.032l.868-2.03L3.78 0c-6.136 1.732-3.936 7.351.475 11.76 4.41 4.41 10.009 6.585 11.745.455L12.252 9.61l-2.007.878c-.34.149-.726.153-1.045-.038"
                    fill="currentColor"
                />
                <path d="m14.168.838-2.87 2.87V1.334h-1.4V6.1h4.765v-1.4h-2.376l2.871-2.871z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
PhoneArrowInFilledSize16Glyph.displayName = 'PhoneArrowInFilledSize16Glyph';
